import React from "react";
import styled from "styled-components";
import { ProcessingOverlay } from "./ProcessingOverlay";

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

interface SavingOverlayProps {
  isVisible: boolean;
  progress: number;
  throughput: number;
  message?: string;
}

export const SavingOverlay: React.FC<SavingOverlayProps> = ({
  isVisible,
  progress,
  throughput,
  message = "Saving record...",
}) => {
  if (!isVisible) return null;

  return (
    <OverlayContainer>
      <ProcessingOverlay
        message={message}
        progress={progress}
        throughput={throughput}
        showStats={true}
      />
    </OverlayContainer>
  );
};
